import { ONBOARDING_SET_VALUE } from '../../constants/actions';

const initialState = {
  firstName: '',
  heightSlider: null,
  selectedEthnicity: '',
  selectedBodyType: '',
  ageRangeSlider: [],
  radiusSlider: 100,
  tagLine: '',
  checkSpecialOffers: false,
  checkTosAndPP: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ONBOARDING_SET_VALUE:
      return { ...state, [action.prop]: action.value };
    default:
      return state;
  }
}
